module.exports = __webpack_public_path__ + "static/media/design.e5f0e804.svg";